
const TrialResultsContent = () => {
    return (
        <>
            <h4>
                ANZ 0001 clinical trial results
            </h4>
            <p>
                ANZ 0001, a study led by Breast Cancer Trials, comparing oral capecitabine with standard chemotherapy (CMF) in women with metastatic breast cancer unsuited to intensive chemotherapy, was published in 2011 in the Journal of Clinical Oncology. Women receiving capecitabine had superior overall survival, with a favourable toxicity profile allowing longer duration of treatment. These results increased the confidence with which clinicians might choose a relatively low toxicity chemotherapy regimen for their patients, without compromising outcomes.
            </p>
        </>
    );
}

export default TrialResultsContent;